import { ROUTES } from '#/config/routes';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { CUSTOMER_STATUS_FILTER_OPTIONS } from '#/modules/crmMgmt/customer/helper/customerStatus';

export function buildCustomerColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.customerDetail(row.id),
      getEditPath: (row) => ROUTES.customerEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '統編',
      accessorKey: 'taxIdNumber',
      size: 120,
      enableColumnFilter: true,
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.taxIdNumber || '—'} />
      ),
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'taxIdNumber',
          label: '統編',
          filterValue: filters.taxIdNumber,
          onChange: (value) => onFilterChange('taxIdNumber', value),
          placeholder: '搜尋統編',
        }),
      },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: CUSTOMER_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (value) => onFilterChange('remark', value),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}
